import React from 'react'
import { motion } from 'framer-motion'
import { FaKeyboard, FaArrowUp, FaArrowDown, FaArrowLeft, FaArrowRight } from 'react-icons/fa'

const ErgonomicsSection = () => {
  const shortcuts = [
    { icon: <FaArrowUp />, label: 'Hauteur +', key: '↑' },
    { icon: <FaArrowDown />, label: 'Hauteur -', key: '↓' },
    { icon: <FaArrowLeft />, label: 'Vitesse -', key: '←' },
    { icon: <FaArrowRight />, label: 'Vitesse +', key: '→' },
    { icon: '⎵', label: 'Pause', key: 'Espace' }
  ]

  return (
    <section className="section-padding bg-white">
      <div className="container-max">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Contenu texte */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Reprenez le contrôle total de vos séances, en toute discrétion.
            </h2>
            
            <p className="text-lg text-gray-600 leading-relaxed mb-8">
              Oubliez les clics de souris... EMDR Plus est pilotable via des raccourcis clavier 
              intuitifs pour la hauteur (↑/↓), la vitesse (←/→) et la pause (Espace). 
              Vos ajustements sont instantanés et transparents.
            </p>

            <div className="flex items-center space-x-2 text-sm text-gray-500">
              <FaKeyboard className="w-4 h-4" />
              <span>Contrôle silencieux et professionnel</span>
            </div>
          </motion.div>

          {/* Visualisation des raccourcis */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="bg-gray-900 rounded-2xl p-8 text-white">
              <h3 className="text-xl font-semibold mb-6 text-center">Raccourcis Clavier</h3>
              
              <div className="grid grid-cols-2 gap-4">
                {shortcuts.map((shortcut, index) => (
                  <motion.div
                    key={index}
                    className="flex items-center space-x-3 p-3 bg-gray-800 rounded-lg"
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                    viewport={{ once: true }}
                  >
                    <div className="w-8 h-8 bg-primary-600 rounded flex items-center justify-center text-sm">
                      {typeof shortcut.icon === 'string' ? shortcut.icon : shortcut.icon}
                    </div>
                    <div>
                      <div className="font-medium text-sm">{shortcut.label}</div>
                      <div className="text-xs text-gray-400">{shortcut.key}</div>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  )
}

export default ErgonomicsSection 